import { Controller } from "@hotwired/stimulus"
import { fetchStream } from "../lib/stream_fetch"

export default class extends Controller {
  static values = { url: String }

  connect() {
    const root = this.#scrollableAncestor()
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) this.#loadNextPage()
      },
      { root, rootMargin: "200px" }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #scrollableAncestor() {
    let el = this.element.parentElement
    while (el && el !== document.documentElement) {
      const { overflow, overflowY } = getComputedStyle(el)
      if (/(auto|scroll)/.test(overflow + overflowY)) return el
      el = el.parentElement
    }
    return null
  }

  async #loadNextPage() {
    this.observer.disconnect()

    const response = await fetchStream(this.urlValue)
    if (response?.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    }
  }
}
